// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 列表 GET /admin/sms_history/list */
export async function getAdminSmsHistoryList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getAdminSmsHistoryListParams,
  options?: { [key: string]: any },
) {
  return request<API.SPageC2ABAdminSmsHistoryVoC2BB>('/admin/sms_history/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
